import React from 'react'
import { Supporter } from '../cards/Supporter'
// import Swiper core and required modules
import { Navigation, Pagination, A11y } from 'swiper/modules';

import { Swiper, SwiperSlide } from 'swiper/react';
import ciif from "../../assets/ciif.png"
import iihmr from "../../assets/iihmr.png"
import nhm from "../../assets/nhmOdisha.png"

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export const Supporters = () => {
    return (
        // This is the supporters section
        <div className='px-[5vw] py-20 w-full bg-[#100c1219]'>
            {/* // This is the title */}
            <h2 className='text-3xl text-blue-500 font-semibold'>Our Supporters</h2>

            {/* // This is the swiper view for small to medium devices.*/}
            <Swiper
                // install Swiper modules
                modules={[Navigation, Pagination, A11y]}
                spaceBetween={50}
                slidesPerView={1}
                navigation
                pagination={{ clickable: true }}
                className='mt-20 lg:hidden w-full'
            >
                {/* // This is the swiper slide */}
                <SwiperSlide className='flex justify-center items-center'>
                    <Supporter name="CIIF" caption="Chitkara University, Chandigarh" logo={ciif} />
                </SwiperSlide>
                <SwiperSlide className='flex justify-center items-center'>
                    <Supporter name="ABDM Integrated" caption="ABDM Partner Solution" logo={iihmr} des="We provide a Plug and Play ABDM integrated HMIS to for making your software M1 and M3 compliant and also help to digitize the front-desk operations." />
                </SwiperSlide>
                <SwiperSlide className='flex justify-center items-center'>
                    <Supporter name="NHA" caption="UHI Partner App" logo={nhm} des="With NHA we are integrating to the UHI network and provide UHI listing to all our hospital Partner and our stakeholders." />
                </SwiperSlide>
            </Swiper>

            {/* // This is the view for Large Devices.*/}
            <div className='max-lg:hidden mt-20 w-full flex flex-wrap gap-3 justify-between items-center'>
                <Supporter name="CIIF" caption="Chitkara University, Chandigarh" logo={ciif} />
                <Supporter name="ABDM Integrated" caption="ABDM Partner Solution" logo={iihmr} des="We provide a Plug and Play ABDM integrated HMIS to for making your software M1 and M3 compliant and also help to digitize the front-desk operations." />
                <Supporter name="NHA" caption="UHI Partner App" logo={nhm} des="With NHA we are integrating to the UHI network and provide UHI listing to all our hospital Partner and our stakeholders." />
            </div>

        </div>
    )
}
